import React, { FC } from 'react'
import cx from 'classnames'
import css from './settings.module.scss'

type PasswordRequirementProps = React.DetailedHTMLProps<
  React.LiHTMLAttributes<HTMLLIElement>,
  HTMLLIElement
> & {
  pass: boolean
}

const PasswordRequirement: FC<React.PropsWithChildren<PasswordRequirementProps>> = ({
  pass,
  className,
  ...props
}) => {
  return (
    <li
      className={cx(css.password_requirement, className, {
        [css.pass]: pass,
      })}
      {...props}
    />
  )
}

export default PasswordRequirement
